/* <sst-feature-hotspots>: image pins and the feature list share one active item. */
if (!customElements.get('sst-feature-hotspots')) {
  customElements.define(
    'sst-feature-hotspots',
    class extends HTMLElement {
      connectedCallback() {
        this.pins = [...this.querySelectorAll('.sst-hotspots__pin')];
        this.items = [...this.querySelectorAll('.sst-hotspots__item')];

        this.querySelectorAll('[data-feature]').forEach((el) => {
          const i = Number(el.dataset.feature);
          el.addEventListener('click', () => this.activate(i));
          el.addEventListener('mouseenter', () => this.activate(i));
        });

        this.addEventListener('shopify:block:select', (e) => this.activate(this.items.indexOf(e.target)));
      }

      activate(i) {
        if (i < 0) return;
        this.pins.forEach((pin, n) => pin.classList.toggle('is-active', n === i));
        this.items.forEach((item, n) => {
          item.classList.toggle('is-active', n === i);
          item.querySelector('[aria-expanded]')?.setAttribute('aria-expanded', n === i);
        });
      }
    }
  );
}
